import { render, staticRenderFns } from "./PowerBILayout.vue?vue&type=template&id=98adb1d8&"
import script from "./PowerBILayout.vue?vue&type=script&lang=js&"
export * from "./PowerBILayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports